import {getFromStore, StorePath} from './store.service';
import {Settings} from '../models/snippet-payload.model';
import {DealerInfo} from '../models/dealership.model';

export const getClientDisplayName = (): string | null => {
	const customClientName = (getFromStore(StorePath.SETTINGS) as Settings)?.gpt_settings?.custom_client_name as string | null;
	const dealerInfoName = (getFromStore(StorePath.DEALER_INFO) as DealerInfo)?.name as string | null;
	return customClientName || dealerInfoName;
};
